module.exports = __webpack_public_path__ + "img/Avatar-30.58fc7c01.svg";